<template>
  <section class="closefriend-hero h-100" >

    <b @click="slideBar()" :class="showSlideBar ? 'screen-overlay show' : 'screen-overlay'"></b>


    <influencer-menu @menuClicked="slideBar()" :show-slide-bar="showSlideBar"></influencer-menu>
    <header-menu @slideMenu="slideBar()" :is-loading="isLoading"></header-menu>

    <div class="container mt-5">
        <div class="row">
          <div class="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-lg-6 offset-lg-3 col-xl-6 offset-xl-3">
            <div class="login-card position-relative">
              <button type="button" class="close position-absolute" style="right: 15px; top: 10px; z-index: 10; color: #fff; font-size: 30px;" aria-label="Close" @click="$router.replace({name: 'BonusContentList'})">
                <span aria-hidden="true">&times;</span>
              </button>
              <global-message></global-message>
              <div class="login-body mt-3">
                <div class="custom-body mb-3">
                </div>

                <div id="show_image_here" class="text-center mb-3" style="cursor:pointer;" v-if="content && content.cdnUrl">
                  <img v-if="content.type === 'IMAGE' || content.type === TYPE_IMAGE"
                       :src="content.cdnUrl"
                       id="user_upload_image"
                       class="placeholder-image border-radius-10 img-fluid">
                  <video v-else-if="content.type === 'VIDEO'" oncontextmenu="return false;" controlsList="nodownload"
                         controls :src="content.cdnUrl"
                         id="user_upload_video"
                         style="max-width: 100%;max-height: 400px;">
                  </video>
                  <div v-else class="text-white py-4 bg-dark border-radius-10">
                    <img src="@/assets/images/download.png" style="width: 64px; opacity: 0.7;">
                    <h5 class="mt-3 text-white-50 mb-0">{{ content.ext || 'File Document' }}</h5>
                  </div>
                </div>
                <label for="description" class="font-grey">
                  Description <required-field v-if="isRequired('description')"/>
                </label>
                <div class="form-group">
                  <textarea
                         class="form-control"
                         rows="3"
                         placeholder="Description"
                         v-model="content.description"
                         style="background-color: #1a1a1a !important; color: #fff !important; border: 1px solid #333 !important;"></textarea>
                </div>

                <div class="form-group">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <label for="price_section" class="font-grey mb-0">
                      Content Price <required-field v-if="isPaid && isRequired('price')"/>
                    </label>
                    <div class="btn-group btn-group-sm" role="group" style="background-color: #1a1a1a; border-radius: 20px; padding: 2px;">
                      <button type="button" 
                              class="btn rounded-pill px-4" 
                              :class="!isPaid ? 'stella-btn gradient-a text-white font-weight-600' : 'text-muted'" 
                              style="border: none; box-shadow: none;"
                              @click="isPaid = false; content.price = null">Free</button>
                      <button type="button" 
                              class="btn rounded-pill px-4" 
                              :class="isPaid ? 'stella-btn gradient-a text-white font-weight-600' : 'text-muted'" 
                              style="border: none; box-shadow: none;"
                              @click="isPaid = true">Paid</button>
                    </div>
                  </div>
                  <div class="input-group" v-if="isPaid" style="max-width: 150px;">
                    <div class="input-group-prepend">
                      <span class="input-group-text" style="background-color: #333; color: #fff; border: 1px solid #333; border-right: none;">$</span>
                    </div>
                    <input type="number" min="0" maxlength="6"
                           :placeholder="pricePlaceHolder"
                           class="form-control"
                           id="price_section"
                           v-model="content.price"
                           oninput="if(this.value.length > 6) this.value = this.value.slice(0, 6);"
                           onkeypress="return event.keyCode === 8 || (event.charCode >= 48 && event.charCode <= 57 && event.target.value.length < 6)"
                           style="background-color: #1a1a1a !important; color: #fff !important; border: 1px solid #333 !important; border-left: none;">
                  </div>
                </div>
              </div>
              <div class="mt-4 mb-2 d-flex justify-content-end">
                <button type="submit" @click="save()"
                        class="btn stella-btn gradient-a rounded-pill font-weight-500 px-5 py-2 w-auto">
                  <span class="text-white font-size-14 font-weight-600">Save</span>
                </button>
              </div>
            </div>
          </div>

        </div>

      </div>
  </section>
</template>

<script>

import {mapActions, mapGetters} from "vuex";

import {httpMixin} from "@/mixin/http-mixin";
import {newSubscriptionMixin} from "@/mixin/new-subscription-mixin";
import HeaderMenu from "@/components/module/influencer/shared/HeaderMenu";
import InfluencerMenu from "@/components/module/influencer/shared/InfluencerMenu";
import InfluencerHeader from "@/components/module/influencer/shared/InfluencerHeader";
import GlobalMessage from "@/components/module/shared/GlobalMessage";
import RequiredField from "@/components/module/shared/RequiredField";
import PwaActionBar from "@/components/module/influencer/shared/PwaActionBar";
import {required} from "vuelidate/lib/validators";
import {constructCustomerURL} from "@/common/baseURL-service";
import {clone} from "@/common/Utils";
import {SERVICE_CONTENT} from "@/properties/micro-service";
import titleMixin from "../../../../mixin/title-mixin";

const TYPE_IMAGE = 'IMAGE';

export default {
  name: 'BonusContentEdit',
  title: 'Edit bonus content',
  mixins: [httpMixin, newSubscriptionMixin, titleMixin],
  components: {
    HeaderMenu, InfluencerMenu,
    InfluencerHeader, GlobalMessage, RequiredField, PwaActionBar
  },
  data() {
    return {
      user: {},
      content: {},
      oldContent: {},
      showSlideBar: false,
      isSubmit: false,
      isVideo: false,
      isPaid: false,
      TYPE_IMAGE
    }
  },
  validations() {
    if (this.isPaid) {
      return {
        content: {
          description: {required},
          price: {required}
        }
      }
    } else {
      return {
        content: {
          description: {required}
        }
      }
    }
  },
  created() {
    this.clearGlobalMessages();
    this.user = this.getUser();
    let contentId = this.$route.params.contentId
    let url = `${SERVICE_CONTENT}/api/v1/influencers/${this.user.id}/content/${contentId}`;
    this.getData(url, (data) => {
      this.oldContent = clone(data);
      this.setUpData(data, true);
    });
  },
  computed: {
    copyLabel() {
      return this.copied ? 'Copied' : 'Copy';
    },
    pricePlaceHolder() {
      return this.isPaid ? 'Price' : 'Free';
    }
  },
  methods: {
    ...mapGetters(['getUser']),
    ...mapActions(['setUser', 'setMessage', 'clearGlobalMessages']),
    constructCustomerURL,
    setUpData(data, toggle) {
      this.content = data;
      if (this.content.price > 0) {
        this.isPaid = true;
        // If it was paid earlier then keep it as paid,
        // otherwise toggle will make it as free
        if (toggle) {
          this.switchOnToggle();
        }
      } else {
        this.content.price = null;
        this.isPaid = false;
      }
    },
    switchOnToggle() {
      this.$nextTick(() => {
        $('#toggle_price').button('toggle');
      });
    },
    save() {

      this.isSubmit = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        console.log('failed', this.$v);
        return;
      }

      this.content.price = this.content.price ? this.content.price : '0'
      let url = `${SERVICE_CONTENT}/api/v1/influencers/${this.user.id}/content/${this.content.id}`;
      this.patchData(url, this.content, (data) => {
        this.setUpData(data, !(this.oldContent.price > 0));
        this.setMessage('SAVED.SUCCESSFULLY');
        this.$router.replace({name: 'BonusContentList', params: {isSaved: true}});
      });
    },
    deleteContent() {

      let url = `${SERVICE_CONTENT}/api/v1/influencers/${this.user.id}/content/${this.content.id}`;
      this.getDelete(url, (data) => {
        this.setMessage('DELETED.SUCCESSFULLY');
        this.$router.replace({name: 'BonusContentList', params: {isDeleted: true}});
      });
    },
    archiveContent() {
      this.oldContent.price = this.oldContent.price ? this.oldContent.price : '0'
      this.oldContent.active = false;
      let url = `${SERVICE_CONTENT}/api/v1/influencers/${this.user.id}/content/${this.oldContent.id}`;
      this.patchData(url, this.oldContent, (data) => {
        this.setMessage('ARCHIVED.SUCCESSFULLY');
        this.$router.replace({name: 'BonusContentList', params: {isArchived: true}});
      });
    },
    isRequired(attrib) {
      return this.isSubmit && !this.$v.content[attrib].required;
    },
    toggle() {
      this.isPaid = !this.isPaid;
      this.content.price = !this.isPaid ? null : this.content.price;
    },
    slideBar() {
      this.showSlideBar = !this.showSlideBar;
    },
  }
}
;
</script>



